class Base {
  setShareInfo() {}
}

export default Base;
